import Heart from './Heart'

export default Heart
// eslint-disable-next-line import/export
export * from './Heart'
